export enum HttpMethod {
  GET = 'GET',
  POST = 'POST',
  PUT = 'PUT',
  DELETE = 'DELETE',
}

export enum ContentType {
  JSON = 'application/json',
  URL_ENCODE = 'application/x-www-form-urlencoded',
  FORM_DATA = 'multipart/form-data',
  OCTET = 'application/octet-stream',
  HTML = 'text/html',
  PLAIN = 'text/plain',
}

export enum ResponseType {
  AB = 'arraybuffer',
  BLOB = 'blob',
  JSON = 'json',
  TEXT = 'text',
  STREAM = 'stream',
}

export enum StatusCode {
  UNAUTHORIZED_401 = 401,
  FORBIDDEN_403 = 403,
  NOT_FOUND_404 = 404,
  METHOD_NOT_ALLOWED_405 = 405,
  REQUEST_TIMEOUT_408 = 408,
  INTERNAL_SERVER_ERROR_500 = 500,
  BAD_GATEWAY_502 = 502,
  SERVICE_UNAVAILABLE_503 = 503,
  GATEWAY_TIMEOUT_504 = 504,
}
